// pages/Login.jsx
import { useState,useEffect } from 'react';
import { Box, TextField, Button, MenuItem } from '@mui/material';
import { useNavigate,useSearchParams } from 'react-router-dom';
import { API_ENDPOINTS } from '../config/constants';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LogoHeader from '../components/LogoHeader';
import axios from 'axios';

const persistUuid = (uuid) => {
    if (uuid) {
        localStorage.setItem('pendingUuid', uuid);
    }
};

const countries = [
    { code: '+91' },
    { code: '+81' }, // Japan
    { code: '+65' },
];

const Login = ({ setPhoneNumber,setOtp }) => {
    const [code, setCode] = useState('+91');
    const [number, setNumber] = useState('');
    const [searchParams] = useSearchParams();
    const uuid = searchParams.get('uuid');
    const navigate = useNavigate();

    const handleContinue = async () => {
        if (number.length >= 6) {
            setPhoneNumber(`${code}${number}`);
            persistUuid(uuid);
            try{
                const response =await axios.post(API_ENDPOINTS.GENERATE_OTP, {
                    phone_number: `${code}${number}`,
                    uuid: uuid || null
                });
                setOtp(response.data.otp);
                navigate('/mobile/OTP-verification'); 
            }
            catch (error) {
                console.error('Error generating OTP:', error);
                alert('Failed to generate OTP. Please try again.');
            }  
        }
    };

    return (
        <>
            <LogoHeader />
            <Box className="card">
                <h2 style={{ color: '#110d31' }}>Login</h2>
                <p style={{ color: '#999' }}>Please enter your mobile number to verify your account.</p>
                <Box display="flex" gap={2} mt={2}>
                    <Box flex="0 0 30%">
                        <TextField
                            select
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            fullWidth
                        >
                            {countries.map((c) => (
                                <MenuItem key={c.code} value={c.code}>
                                    {c.label} ({c.code})
                                </MenuItem>
                            ))}
                        </TextField>
                    </Box>

                    <Box flex="0 0 60%">
                        <TextField
                            placeholder="000000"
                            type="number"
                            value={number}
                            onChange={(e) => setNumber(e.target.value)}
                            fullWidth
                        />
                    </Box>
                </Box>

                <Button
                    variant="contained"
                    endIcon={<ArrowForwardIcon />}
                    onClick={handleContinue}
                    sx={{ mt: 3, background: '#110d31' }}
                    fullWidth
                >
                    Continue
                </Button>
            </Box>
        </>
    );
};

export default Login;
